import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";

import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AcceptInvite from "@/pages/AcceptInvite";

import AppLayout from "@/components/AppLayout";
import SuperAdmin from "@/pages/SuperAdmin";
import Dashboard from "@/pages/Dashboard";
import Partners from "@/pages/Partners";
import Accounting from "@/pages/Accounting";
import CashBank from "@/pages/CashBank";
import BankReconciliation from "@/pages/BankReconciliation";
import Inventory from "@/pages/Inventory";
import Sales from "@/pages/Sales";
import RecurringInvoices from "@/pages/RecurringInvoices";
import Purchases from "@/pages/Purchases";
import FixedAssets from "@/pages/FixedAssets";
import AIChat from "@/pages/AIChat";
import Telegram from "@/pages/Telegram";
import WhatsApp from "@/pages/WhatsApp";
import Billing from "@/pages/Billing";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import CustomReports from "@/pages/CustomReports";
import AdvancedReports from "@/pages/AdvancedReports";
import AuditLog from "@/pages/AuditLog";
import AnnualReport from "@/pages/AnnualReport";
import FundRequests from "@/pages/FundRequests";
import EBupot from "@/pages/EBupot";
import Projects from "@/pages/Projects";
import Payroll from "@/pages/Payroll";
import Roles from "@/pages/Roles";
import Approvals from "@/pages/Approvals";
import TaxRegulations from "@/pages/TaxRegulations";
import Panduan from "@/pages/Panduan";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/app" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="partners" element={<Partners />} />
              <Route path="accounting" element={<Accounting />} />
              <Route path="cashbank" element={<CashBank />} />
              <Route path="bank-reconciliation" element={<BankReconciliation />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="sales" element={<Sales />} />
              <Route path="sales-recurring" element={<RecurringInvoices />} />
              <Route path="purchases" element={<Purchases />} />
              <Route path="fixed-assets" element={<FixedAssets />} />
              <Route path="reports" element={<Reports />} />
              <Route path="custom-reports" element={<CustomReports />} />
              <Route path="advanced-reports" element={<AdvancedReports />} />
              <Route path="audit-log" element={<AuditLog />} />
              <Route path="annual-report" element={<AnnualReport />} />
              <Route path="fund-requests" element={<FundRequests />} />
              <Route path="ebupot" element={<EBupot />} />
              <Route path="projects" element={<Projects />} />
              <Route path="payroll" element={<Payroll />} />
              <Route path="roles" element={<Roles />} />
              <Route path="tax-regulations" element={<TaxRegulations />} />
              <Route path="approvals" element={<Approvals />} />
              <Route path="ai" element={<AIChat />} />
              <Route path="telegram" element={<Telegram />} />
              <Route path="whatsapp" element={<WhatsApp />} />
              <Route path="team" element={<Team />} />
              <Route path="billing" element={<Billing />} />
              <Route path="settings" element={<Settings />} />
              <Route path="superadmin" element={<SuperAdmin />} />
              <Route path="panduan" element={<Panduan />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
